import React, { useState } from "react";
import "../styles/Testimonial.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
const Testimonials = () => {
  const testimonials = 
[
  {
    text: `"Square Feet Marble is the best imported marble supplier in Kishangarh. Their Italian Statuario quality is flawless and perfect for luxury homes. If you are looking for premium imported marble, this is the place to trust."`,
    author: "Arjun Reddy",
    role: "Lead Architect, Urban Design Studio",
    initials: "AR",
    stars: "★★★★★",
  },
  {
    text: `"Their collection of Italian and imported marble is unmatched in India. The finish and polish were exactly what we needed for a luxury villa. Highly recommended if you want top-quality marble for your next project."`,
    author: "Priya Sharma",
    role: "Interior Designer, Luxury Spaces",
    initials: "PS",
    stars: "★★★★★",
  },
  {
    text: `"We’ve worked with Square Feet Marble for 10+ years. Their consistency in imported marble quality and service is incredible. If you want reliability and premium quality, they are the right choice."`,
    author: "Rajesh Kumar",
    role: "CEO, Elite Constructions",
    initials: "RK",
    stars: "★★★★★",
  },
  {
    text: `"One of the top imported marble dealers in Kishangarh. Their Statuario, and exotic stones are exceptional. If you are searching for authentic Italian marble, look no further."`,
    author: "Mohit Verma",
    role: "Architect, VM Designs",
    initials: "MV",
    stars: "★★★★★",
  },
  {
    text: `"Their showroom has India’s most premium imported marble selection. The team guided us perfectly in choosing slabs for our luxury flat. Perfect place if you want expert guidance and quality marble."`,
    author: "Neha Gupta",
    role: "Interior Consultant",
    initials: "NG",
    stars: "★★★★★",
  },
  {
    text: `"Square Feet Marble supplied imported marble for our resort project, and the results were outstanding. If you need marble with international quality standards, this is the best supplier."`,
    author: "Kunal Singh",
    role: "Project Manager, Royal Resorts",
    initials: "KS",
    stars: "★★★★★",
  },
  {
    text: `"Their Italian marble range truly defines luxury. Our corporate office looks premium and elegant. A great option for anyone looking for high-end imported marble in India."`,
    author: "Sanjay Patel",
    role: "Corporate Designer",
    initials: "SP",
    stars: "★★★★★",
  },
  {
    text: `"Best imported marble dealer in Kishangarh. Their knowledge, pricing, and service are far better than others. If you are building a premium space, you should visit them first."`,
    author: "Riya Mehta",
    role: "Architect, RM Studios",
    initials: "RM",
    stars: "★★★★★",
  },
  {
    text: `"We selected their Statuario and Beige marble for a luxury farmhouse. The shine and strength are perfect. If you want long-lasting luxury, Square Feet Marble is highly recommended."`,
    author: "Kabir Khan",
    role: "Builder, KK Infra",
    initials: "KK",
    stars: "★★★★★",
  },
  {
    text: `"Every slab in their imported marble collection is premium and beautifully polished. The quality speaks for itself. A must-visit if you want superior marble quality."}`,
    author: "Anita Sharma",
    role: "Interior Designer",
    initials: "AS",
    stars: "★★★★★",
  },
  {
    text: `"Their white imported marble is the cleanest and most premium we’ve seen. Our hotel rooms now look brighter and more luxurious. If you want bright white marble, this is the best source."`,
    author: "Sameer Desai",
    role: "Hotel Owner",
    initials: "SD",
    stars: "★★★★★",
  },
  {
    text: `"Authentic imported marble with perfect polish and finish. Square Feet Marble truly stands out as India’s best imported marble supplier. Choose them if quality matters to you."`,
    author: "Vikas Chaudhary",
    role: "Civil Contractor",
    initials: "VC",
    stars: "★★★★★",
  },
  {
    text: `"Their highlighter and beige marble collection is stunning. It added elegance to our retail showroom. If you want rare and unique marble, this place has the best variety."}`,
    author: "Deepika Rao",
    role: "Brand Manager",
    initials: "DR",
    stars: "★★★★★",
  },
  {
    text: `"The team helped us select marble with proper thickness, polish, and finishing. Everything was delivered safely and on time. A perfect choice for anyone who values professionalism."`,
    author: "Amit Jain",
    role: "Homeowner",
    initials: "AJ",
    stars: "★★★★★",
  },
  {
    text: `"Genuine imported marble at genuine prices. Their Kishangarh showroom is very well organized. If you are looking for the best marble dealer, this place is ideal."`,
    author: "Harshvardhan Singh",
    role: "Real Estate Developer",
    initials: "HS",
    stars: "★★★★★",
  },
  {
    text: `"We used their Italian marble for a luxury villa project. The natural veins and shine are unbelievably beautiful. Highly recommended for premium residential projects."`,
    author: "Maya Kapoor",
    role: "Architect",
    initials: "MK",
    stars: "★★★★★",
  },
  {
    text: `"Square Feet Marble consistently delivers the best imported marble for our hotel and villa projects. If you want a long-term reliable supplier, choose them without hesitation."`,
    author: "Rohit Agarwal",
    role: "Interior Contractor",
    initials: "RA",
    stars: "★★★★★",
  },
  {
    text: `"Beautiful color, perfect polish, and superior stone strength. Their Italian marble is worth every penny. A great choice for anyone upgrading their interiors."`,
    author: "Shivani Arora",
    role: "Interior Stylist",
    initials: "SA",
    stars: "★★★★★",
  },
  {
    text: `"Top imported marble dealer in Kishangarh with a fresh and premium collection. Makes selection easy and stress-free. Visit once if you want exclusive marble options."}`,
    author: "Nikhil Soni",
    role: "Architect",
    initials: "NS",
    stars: "★★★★★",
  },
  {
    text: `"Their imported marble completely transformed our home’s flooring and walls. Pure luxury and value for money. If you're searching for long-lasting premium marble, go with Square Feet Marble."`,
    author: "Garima Jain",
    role: "Homeowner",
    initials: "GJ",
    stars: "★★★★★",
  }
];

  const [activeIndex, setActiveIndex] = useState(0);

  const nextTestimonial = () => {
    setActiveIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setActiveIndex((prev) =>
      prev === 0 ? testimonials.length - 1 : prev - 1
    );
  };

  return (
    <section id="testimonials" className="section">
      <h2 className="section-title">Real Experiences. Real Trust</h2>

      <div className="testimonial-slider">
        {testimonials.map((item, index) => (
          <div
            key={index}
            className={`testimonial-card ${
              index === activeIndex ? "active" : ""
            }`}
          >
            <p className="testimonial-text">{item.text}</p>
            <div className="testimonial-author">
              <div className="author-img">{item.initials}</div>
              <div>
                <h4>{item.author}</h4>
                <p style={{ color: "rgba(255,255,255,0.6)" }}>{item.role}</p>
                <div className="stars">{item.stars}</div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="slider-controls">
        <button className="slider-btn" onClick={prevTestimonial}>
          <FontAwesomeIcon icon={faChevronLeft} />
        </button>
        <button className="slider-btn" onClick={nextTestimonial}>
          <FontAwesomeIcon icon={faChevronRight} />
        </button>
      </div>
    </section>
  );
};

export default Testimonials;
